import React from 'react'
import type { NativeStackScreenProps } from '@react-navigation/native-stack'

// Components
import NoticeBarContainer from 'APP/Components/NoticeBarContainer'
import DialogueWebView from 'APP/Components/DialogueWebView'

// Generic WebContentScreen constrained to routes that have uri in params
type WebContentRoutes =
  | 'helpDocument'
  | 'consentDocument'
  | 'embeddedUrlWithAuth'
  | 'guardianConsentDocument'
  | 'promotedContent'

const WebContentScreen = <T extends WebContentRoutes>(
  props: NativeStackScreenProps<ReactNavigation.RootParamList, T>
) => {
  // All WebContentRoutes are guaranteed to have uri: string in RootParamList
  const { uri, title, headers } = props.route.params!

  return (
    <NoticeBarContainer>
      <DialogueWebView uri={uri} title={title} headers={headers} route={props.route} />
    </NoticeBarContainer>
  )
}

export default WebContentScreen
